<template>
  <div v-if="routePath === '/detail'" id="app1" :style="bgStyle">
    <layout-header></layout-header>
    <router-view class="content" />
  </div>
  <div v-else id="app">
    <router-view class="content" />
  </div>
</template>

<script>
import autofit from "autofit.js";
import LayoutHeader from "@/views/layout-header/index";
import { elRectification } from "autofit.js";
import { getImageUrl } from "@/utils/image";

export default {
  components: { LayoutHeader },
  data() {
    return {
      routePath: "",
      bgImageUrl: "",
      bgStyle: {},
    };
  },
  created() {
    setTimeout(() => {
      this.initPath();
    }, 200);
    // 设置背景图片URL
    this.bgImageUrl = getImageUrl("images/bg-detail.png");
    // 设置背景样式
    this.bgStyle = {
      background: `url(${this.bgImageUrl}) no-repeat`,
      backgroundSize: "100% 100%",
    };
  },
  watch: {
    $route() {
      this.initPath();
    },
  },
  methods: {
    initPath() {
      this.routePath = this.$route.path;
    },
  },
  mounted() {
    autofit.init({
      dh: 1080,
      dw: 1920,
      el: "#app",
      resize: true,
      ignore: ['div[id*="el-tooltip"]'],
    });
    elRectification('div[id*="el-tooltip"]');

    // 不再需要在这里设置背景，因为我们使用了绑定样式
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app1 {
  width: 100%;
  height: 100%;
  color: #fff;
  /* 背景样式通过绑定设置 */
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 1px;
  }
  .content {
    padding: 20px 30px 0 30px;
    overflow: auto;
    -ms-overflow-style: none; /* IE 10+ */
    scrollbar-width: none; /* Firefox */
  }
}

#app {
  width: 100%;
  height: 100%;
  color: #fff;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 1px;
  }
  .content {
    /*padding: 20px 30px 0 30px;*/
    overflow: auto;
    -ms-overflow-style: none; /* IE 10+ */
    scrollbar-width: none; /* Firefox */
  }
}
</style>
